import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const CategoryNav = () => {
  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-100/80 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-600 transition-colors duration-300`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-700 transition-colors duration-300">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryNav;